import React, { useState, useEffect } from 'react'

import { authedAxios } from '../utils'
import { useParams } from 'react-router-dom'
import DocumentList from '../common/documents/DocumentList'
import { Typography, Button, Box } from '@mui/material'
import { UploadFile } from '@mui/icons-material'

import useDropdowns from '../hooks/api/useDropdowns'
import useIsMobile from '../hooks/useIsMobile'
import DocumentCategories from './DocumentCategories'

const Documents = () => {
  const { id } = useParams()
  let inputRef

  const [isEditing, setIsEditing] = useState(false)
  const [documents, setDocuments] = useState([])

  const [loading, setLoading] = useState(false)
  const [errorLoading, setErrorLoading] = useState(false)
  const [isUploading, setIsUploading] = useState(false)
  const [hasUploadError, setHasUploadError] = useState(false)

  const [tab, setTab] = useState(0)

  const userIsAdmin = true

  const { dropdownsSummary } = useDropdowns()

  const documentCategoryDropdown = dropdownsSummary.find(
    (dd) => dd.key === 'documentCategory'
  )

  const getDocuments = () => {
    setLoading(true)
    authedAxios
      .get(`/api/document`)
      .then((res) => {
        setLoading(false)
        setDocuments(res.data.documents)
      })
      .catch((_e) => {
        setErrorLoading(true)
      })
  }

  useEffect(() => {
    getDocuments()
  }, [])

  const handleSelectFile = (e) => {
    if (e.target.files && e.target.files[0]) {
      handleFileUpload(e.target.files[0])
    }
  }

  const getSelectedCategoryTypeId = () => {
    if (tab === 0) return null

    return documentCategoryDropdown?.options?.[tab - 1]?.id
  }

  const selectedCategoryTypeId = getSelectedCategoryTypeId()

  const displayDocuments = documents.filter(
    (d) => d.categoryTypeId === selectedCategoryTypeId
  )

  const handleFileUpload = (file) => {
    setIsUploading(true)

    const formData = new FormData()
    formData.append('file', file)

    return authedAxios
      .put(`/api/document/${selectedCategoryTypeId}`, formData, {
        headers: {
          'content-type': 'multipart/form-data',
        },
      })
      .then(() => {
        setIsUploading(false)
        getDocuments()
      })
      .catch(() => {
        setHasUploadError(true)
        setIsUploading(false)
      })
      .finally(() => {
        const inputEl = document.getElementById('document-input')
        inputEl.value = ''
      })
  }

  const isMobile = useIsMobile()

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant='h6'>Documents</Typography>
        {userIsAdmin && (
          <>
            <Button onClick={() => inputRef.click()} endIcon={<UploadFile />}>
              {' '}
              Upload a document
            </Button>
            <input
              id='document-input'
              hidden
              type='file'
              onChange={handleSelectFile}
              ref={(fileInputRef) => (inputRef = fileInputRef)}
            />
          </>
        )}
      </Box>
      <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row' }}>
        <DocumentCategories
          tab={tab}
          setTab={setTab}
          documentCategoryDropdown={documentCategoryDropdown}
        />
        <Box sx={{ mt: 2 }}>
          <Typography>Results</Typography>
          <DocumentList
            documentCategoryDropdown={documentCategoryDropdown}
            documents={displayDocuments}
            removeDocument={(document) => {
              setDocuments((prev) => {
                return prev.filter((d) => d.s3Key !== document.s3Key)
              })
            }}
            setDocument={(document) => {
              setDocuments((prev) =>
                prev.map((d) => {
                  if (d.s3Key !== document.s3Key) return d
                  return document
                })
              )
            }}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default Documents
